"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelnuovo-bocca-d-adda": {
    "ad42ce39": [{
      "hkey": "a92886c2",
      "slug": "sant-antonio-falcone",
      "name": "Sant'Antonio-Falcone",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antonio": [{
      "hkey": "a92886c2",
      "slug": "sant-antonio-falcone",
      "name": "Sant'Antonio-Falcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;